import Vue from 'vue';
import VueRouter from 'vue-router';
import HubPage from '../views/HubPage.vue';
import TradeFlowPage from '../views/TradeFlowPage.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: HubPage, meta: { vertical: 'hub' } },
  { path: '/tradeflow', component: TradeFlowPage, meta: { vertical: 'tradeflow' } },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 80 } };
    }
    return savedPosition || { x: 0, y: 0 };
  },
});

export default router;
